module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-324.19cc526a.jpg";